<template>
    <div class="wapper pr" :style="'background-color:' + (pageData && pageData.theme)">
        <img v-if="showBack" @click="goHome" src="@/assets/image/back.png" class="back" alt="">
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
        <!-- <div class="tuichu" @click="logout">退出</div> -->
    </div>
</template>

<script>
import Vue from 'vue';
import { cookie } from '@/assets/js/utils'

export default {
    data () {
        return {
            showBack: true,
            pageData: {
                theme: '#aa010d'
            }
        }
    },
    watch: {
        $route (to, from) {
            let t = setTimeout(() => {
                clearTimeout(t);
                document.documentElement.scrollTop = 0
            }, 100)
            if (this.$route.path.includes('chou_jiang') && !this.$route.path.includes('chou_jiang_ji_lu')) {
                document.getElementsByTagName('html')[0].style.backgroundColor = '#aa010d'

            } else {
                document.getElementsByTagName('html')[0].style.backgroundColor = this.pageData.theme

            }
            if (!(this.$route.path.includes('chou_jiang') || this.$route.path.includes('yao_qing_ji_lu') || this.$route.path.includes('pai_hang_bang') || this.$route.path.includes('gui_ze'))) {
                this.showBack = false;
            } else {
                this.showBack = true;
            }


        }
    },
    // watch:{
    //     $route(to, from){
    //         alert(333)
    //         // 
    //         if(to.name.a.includes('chou_jiang')){
    //             // console.log(to)
    //             this.theme = "red"
    //         }
    //     }
    // },
    mounted () {

        // Vue.prototype.pageData = {
        //     theme: '#8f3a2c'
        // }
        let t = setTimeout(() => {
            clearTimeout(t);
            document.documentElement.scrollTop = 0
        }, 100)
        if (this.$route.path.includes('chou_jiang') && !this.$route.path.includes('chou_jiang_ji_lu')) {
            document.getElementsByTagName('html')[0].style.backgroundColor = '#aa010d'

        } else {
            document.getElementsByTagName('html')[0].style.backgroundColor = this.pageData.theme

        }
        if (!(this.$route.path.includes('chou_jiang') || this.$route.path.includes('pai_hang_bang') || this.$route.path.includes('yao_qing_ji_lu') || this.$route.path.includes('da_ti') || this.$route.path.includes('gui_ze'))) {
            this.showBack = false;
        } else {
            this.showBack = true;
        }

    },
    methods: {
        // logout(){

        // },
        goHome () {
            this.$router.push('/')
        }
    },
}
</script>

<style lang="less">
@import '../assets/css/base.less';

.tuichu {
    width: 60px;
    height: 60px;
    text-align: center;
    line-height: 60px;
    background-color: rgba(255, 255, 255, 0.6);
    position: fixed;
    right: 0;
    top: 40%;
}

.wapper {
    background-image: url(../assets/image/n_bg.png);
    background-size: 100% auto;
    background-color: #aa010d;
    // padding: @page-padd @page-padd 6vw;
}
</style>